// extracted by mini-css-extract-plugin
export default {"content":"editpost_content__RRoob","delete_btn":"editpost_delete_btn__NWZHf"};